var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", { staticClass: "text-h5 q-mt-lg q-mb-md" }, [
        _vm._v(_vm._s(_vm.$t(_vm.game_data.game_name)))
      ]),
      _c(
        "q-collapsible",
        {
          staticClass: "shadow-2 q-pa-sm q-ma-xs rounded-border",
          attrs: {
            icon: "far fa-ballot-check",
            "right-icon": "far fa-ballot-check",
            label: _vm.$t("how_to_create_the_game")
          }
        },
        [
          _c("div", { staticClass: "q-ma-sm" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("this_or_that_instructions")))]),
            _c("p", { staticClass: "q-mt-lg" }, [
              _c("em", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("warning") + ": "))]),
                _vm._v(_vm._s(_vm.$t("create_game_before_save")))
              ])
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 q-mb-md" }, [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _vm.game_data.options.length
                  ? _c(
                      "q-list",
                      {
                        staticClass: "q-mt-md",
                        attrs: {
                          dense: "",
                          bordered: "",
                          padding: "",
                          separator: ""
                        }
                      },
                      _vm._l(_vm.game_data.options, function(option, index) {
                        return _c(
                          "q-item",
                          { key: index },
                          [
                            _c(
                              "q-item-main",
                              { staticClass: "q-mx-sm q-mt-sm row" },
                              [
                                _c(
                                  "q-field",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-4 col-4 q-px-sm",
                                    attrs: { count: 80 }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: "2",
                                        "max-height": 80,
                                        "float-label": _vm.$t("this"),
                                        error:
                                          _vm.$v.game_data.options.$each[index]
                                            .this.text.$error
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.game_built
                                            ? _vm.resetGame()
                                            : null
                                        },
                                        input:
                                          _vm.$v.game_data.options.$each[index]
                                            .this.text.$touch
                                      },
                                      model: {
                                        value: option.this.text,
                                        callback: function($$v) {
                                          _vm.$set(option.this, "text", $$v)
                                        },
                                        expression: "option.this.text"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-field",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-4 col-4 q-px-sm",
                                    attrs: { count: 120 }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: "2",
                                        "max-height": 80,
                                        "float-label": _vm.$t("description"),
                                        error:
                                          _vm.$v.game_data.options.$each[index]
                                            .question.$error
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.game_built
                                            ? _vm.resetGame()
                                            : null
                                        },
                                        input:
                                          _vm.$v.game_data.options.$each[index]
                                            .question.$touch
                                      },
                                      model: {
                                        value: option.question,
                                        callback: function($$v) {
                                          _vm.$set(option, "question", $$v)
                                        },
                                        expression: "option.question"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-field",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-4 col-4 q-px-sm",
                                    attrs: { count: 80 }
                                  },
                                  [
                                    _c("q-input", {
                                      attrs: {
                                        type: "textarea",
                                        rows: "2",
                                        "max-height": 80,
                                        "float-label": _vm.$t("that"),
                                        error:
                                          _vm.$v.game_data.options.$each[index]
                                            .that.text.$error
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.game_built
                                            ? _vm.resetGame()
                                            : null
                                        },
                                        input:
                                          _vm.$v.game_data.options.$each[index]
                                            .that.text.$touch
                                      },
                                      model: {
                                        value: option.that.text,
                                        callback: function($$v) {
                                          _vm.$set(option.that, "text", $$v)
                                        },
                                        expression: "option.that.text"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "q-field",
                                  { staticClass: "col-12 q-my-sm" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "row justify-center" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("q-btn-toggle", {
                                              attrs: { options: _vm.selectors },
                                              model: {
                                                value: option.correct_choice,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    option,
                                                    "correct_choice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "option.correct_choice"
                                              }
                                            }),
                                            option.question.length &&
                                            option.this.text.length &&
                                            option.that.text.length
                                              ? _c("q-icon", {
                                                  staticClass: "q-mx-md",
                                                  attrs: {
                                                    name: "fal fa-check",
                                                    color: "positive"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm.game_data.options.length > 2
                                              ? _c(
                                                  "q-btn",
                                                  {
                                                    attrs: {
                                                      round: "",
                                                      flat: "",
                                                      color: "negative",
                                                      icon: "fal fa-trash"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removeWord(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("q-tooltip", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t("remove")
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "row justify-end q-mr-md q-mt-md" },
                  [
                    _c("q-btn", {
                      staticClass: "q-mr-md",
                      attrs: {
                        color: "primary",
                        icon: "far fa-plus",
                        label: _vm.$t("add"),
                        disable: _vm.game_data.options.length > 9
                      },
                      on: { click: _vm.addOption }
                    }),
                    _c("q-btn", {
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("preview"),
                        disable: _vm.disableGamePreview
                      },
                      on: { click: _vm.buildGamePreview }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm.show_game_preview
        ? _c("this-or-that-preview", {
            attrs: {
              show_game_preview: _vm.show_game_preview,
              game_name: _vm.game_data.game_name,
              game_options: _vm.game_data.options
            },
            on: {
              hide_preview: function($event) {
                return _vm.hidePreview()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }